import React from 'react';  
import './index.css';
 import NoContent from 'component/noContent';
class InfoIntro extends React.Component{
  render(){
    const {data}= this.props; 
    return (
      <div className="tab-intro">
        <div className="intro-title">
          <p>实验简介</p>
        </div>
        <div className="intro-main" >
          {
            data&&data.get('content')&&data.getIn(['content', 'brief'])
            ?
            <p dangerouslySetInnerHTML={{__html:data.getIn(['content', 'brief'])}}></p>
            :
            <NoContent/>
          }
        </div>
        <div className="intro-title">
          <p>实验内容</p>
        </div>
        <div className="intro-main" >
          {
            data&&data.get('content')&&data.getIn(['content', 'content'])
            ?
            <p dangerouslySetInnerHTML={{__html:data.getIn(['content', 'content'])}}></p>
            :
            <NoContent/>
          }
        </div>
      </div>
      )
  }
}
export default InfoIntro;